import React from 'react'
import PropTypes from 'prop-types'
import Jsonld from '@/modern/components/Seo/Jsonld'
import { VEHICLE_TYPE } from '@/utils/constants'
import { SCHEMA_CONTEXT } from '@/modern/components/Seo/schemas/constants'
import {
  getItemCondition,
  buildSchemaId,
} from '@/modern/components/Seo/schemas/helpers/schemaCommon.helper'
import {
  parseYear,
  buildMileageFromOdometer,
} from '@/modern/components/Seo/schemas/helpers/VehicleSchema.helper'

export default function VehicleSchema({
  ad,
  vehicleType,
  color,
  canonical,
  isVehicleValid,
}) {
  if (!isVehicleValid) return null

  const { Specification: spec } = ad
  const schemaType = vehicleType === VEHICLE_TYPE.bike ? 'Motorcycle' : 'Car'
  const id = buildSchemaId(canonical)
  const itemCondition = getItemCondition(spec)
  const mileageValue = Number.parseFloat(spec.Odometer)
  const vehicleModelDate = parseYear(spec.YearModel)
  const productionDate = parseYear(spec.YearFabrication)
  const mileageFromOdometer = buildMileageFromOdometer(mileageValue)
  const schemaTypeId = 'jsonld_vehicle_da'

  const json = {
    '@context': SCHEMA_CONTEXT,
    '@type': schemaType,
    '@id': id,
    model: spec.Model.Value,
    ...(spec.Version?.Value && {
      vehicleConfiguration: spec.Version.Value,
    }),
    ...(vehicleModelDate && { vehicleModelDate }),
    ...(productionDate && { productionDate }),
    ...(itemCondition && {
      itemCondition: `${SCHEMA_CONTEXT}/${itemCondition}`,
    }),
    ...(mileageFromOdometer && { mileageFromOdometer }),
    ...(spec.Transmission && { vehicleTransmission: spec.Transmission }),
    ...(spec.BodyType && { bodyType: spec.BodyType }),
    ...(spec.Fuel && { fuelType: spec.Fuel }),
    ...(color && color !== 'Indefinida' && { color }),
  }

  return <Jsonld id={schemaTypeId} dataSchema={json} dataQa={schemaTypeId} />
}

VehicleSchema.propTypes = {
  ad: PropTypes.shape({
    Specification: PropTypes.shape({
      Model: PropTypes.shape({ Value: PropTypes.string }),
      Version: PropTypes.shape({ Value: PropTypes.string }),
      YearModel: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      YearFabrication: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]),
      Odometer: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      Transmission: PropTypes.string,
      BodyType: PropTypes.string,
      Fuel: PropTypes.string,
    }),
  }),
  vehicleType: PropTypes.string,
  color: PropTypes.string,
  canonical: PropTypes.string,
  isVehicleValid: PropTypes.bool.isRequired,
}

VehicleSchema.defaultProps = {
  ad: undefined,
  vehicleType: undefined,
  color: undefined,
  canonical: undefined,
}
